<template>
  <div id="app">
    <div id="appcontent">
      <FixNavBar></FixNavBar>
      <Topbox></Topbox>
      <NavBar></NavBar>
      <MalSwiper></MalSwiper>
      <MalBody></MalBody>
    </div>
    <Bottombox></Bottombox>
  </div>
</template>

<script>
import api from "./api"; // 导入api接口
import FixNavBar from "./views/mainpage/FixNavBar.vue";
import Topbox from "./views/mainpage/Topbox.vue";
import NavBar from "./views/mainpage/NavBar.vue";
import MalSwiper from "./views/mainpage/MalSwiper.vue";
import MalBody from "./views/mainpage/MalBody.vue";
import Bottombox from "./views/mainpage/Bottombox.vue";
export default {
  components: {
    FixNavBar: FixNavBar,
    Topbox: Topbox,
    NavBar: NavBar,
    MalSwiper: MalSwiper,
    MalBody: MalBody,
    Bottombox: Bottombox,
  },
  data() {
    return {
      source: this.$store.state.source,
    };
  },
  beforeCreate() {
    document.title = this.$store.state.malMainPageConfig.constant.title;
  },
};
</script>

<style lang="scss">
body {
  margin: 0px;
  background-color: #f5f5f5;
}

#app {
  display:flex;
  flex-direction:column;
  height:100%;
}

#appcontent {
  flex-shrink:0;
  flex-grow:1
}
//修改滚动条样式
::-webkit-scrollbar {
  width: 8px !important;
  height: 8px !important;
  overflow: visible;
}
::-webkit-scrollbar-thumb {
  //滑块部分
  min-height: 28px;
  height: 5px;
  min-width: 2px;
  width: 5px;
  background: #b8b8b8;
  border-radius: 4px;
  border: solid transparent;
  padding: 100px 0 0;
  border-width: 1px;
  background-color: rgba(138, 153, 170, 0.6);
  background-clip: padding-box;
}
::-webkit-scrollbar-track {
  //轨道部分
  border-radius: 10px;
}
::-webkit-scrollbar-corner {
  background: 0 0;
}
::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}
</style>
